export function parseLocationSearchState(params) {
    const where = params.get('where') || '';
    const lat = params.get('lat');
    const lng = params.get('lng');

    // The backend still supports text-based scopes for old/bookmarked URLs.
    // Treat those as selected without allowing newly typed free text through.
    let whereData = where ? { lat: null, lng: null } : null;

    if (lat && lng) {
        whereData = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
            placeType: params.get('placeType') || undefined
        };
    }

    return { where, whereData };
}
